import React, { PropsWithChildren, useEffect, useState } from "react";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Advantages from "../components/Advantages";
import { Head } from "@inertiajs/react";
import { useAppState } from "../contexts/AppContext";

dayjs.extend(localizedFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

interface AppLayoutProps {
    user?: boolean
}

export default function AppLayout({ children, user = false }: PropsWithChildren<AppLayoutProps>) {
    const { appState } = useAppState()

    return (
        <div>
            <Head>
                <title>Compare Tech Prices in Canada | PriceHunt.ca</title>
                <meta head-key="description" name="description" content={'Compare prices for computer parts and electronics in Canada. PriceHunt.ca helps you find the best deals from top retailers, updated daily.'} />
                <meta head-key="keywords" name="keywords" content="compare prices Canada, CPUs, PC parts, electronics deals, tech shopping, best price, price tracker" />
            </Head>
            <Navbar user={user} />
            <div className="w-full">
                <div className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-col space-y-7">
                    <div className="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 my-6 rounded">
                        <p className="font-bold text-lg">PriceHunt.ca is growing!</p>
                        <p className="mt-2 text-sm">
                            We're actively adding more products, categories, and price comparisons across Canada.
                            The site is in active development — stay tuned for daily updates and new features like price tracking and best deals!
                        </p>
                    </div>
                </div>
            </div>
            {children}
            <Footer />
        </div>
    )
}